export default __webpack_public_path__ + "static/media/UCityProWeb-Bold.fe00133c.woff";